import { apiClient } from "../api/ApiClient";
import type { Category } from "../models/Category";
import type { KeyValue } from "../models/KeyValue";
import { PagedResult } from "../models/PagedResult";
import { SearchParam } from "../models/SearchParam";
import { Status } from "../models/Status";
import { CreateCrudService } from "./CrudServiceFactory";
import { BuildFormData } from "../utils/Util";
import { DataState } from "../models/DataState";

export function CategoryService() {
  const route = "category";
  const GetActivePartial = async (
    skip = 0,
    limit = 50,
  ): Promise<PagedResult<KeyValue>> => {
    const response = await apiClient.post<PagedResult<Record<string, unknown>>>(
      `${route}/SearchDynamic/${skip}/${limit}`,
      {
        Fields: ["Name", "Code"],
        Filters: [
          {
            Field: "Status",
            Operator: "EQ",
            Value: 0,
          },
        ],
      } as SearchParam,
      {
        busyMessage: "Loading active categories...",
      },
    );

    return {
      ...response.data,
      Data: response.data.Data.map((value) => ({
        Key: String(value.Code ?? ""),
        Value: String(value.Name ?? ""),
      })),
    };
  };
  const crudService = CreateCrudService<Category, KeyValue>({
    Route: "category",
    EntityName: "Category",
    PartialFields: ["Name", "Code"],
    LoadingMessage: "Loading categories...",
    SavingMessage: "Saving category...",
    MapPartial: (value) => ({
      Key: String(value.Code ?? ""),
      Value: String(value.Name ?? ""),
    }),
    SaveRequest: async (data) => {
      // The current multipart endpoint rejects an empty code before saving.
      // Generate one for new categories so callers do not have to enter it.
      const models = (data as Category[]).map((category) =>
        category.DataState === DataState.New && !category.Code?.trim()
          ? { ...category, Code: `CAT-${crypto.randomUUID().replace(/-/g, "").toUpperCase()}` }
          : category,
      );
      const response = await apiClient.post<Category[]>(
        `${route}/SaveCategory`,
        BuildFormData({ model: models }, { MaximumFieldCount: 500 }),
        { busyMessage: "Saving category..." },
      );
      return response.data;
    },
  });

  return {
    ...crudService,
    GetActivePartial,
  };
}
